module.exports = __webpack_public_path__ + "img/melli.8426e558.png";